<script setup lang="ts">
import { useConnectivityStore } from '../stores/connectivity'
const connectivity = useConnectivityStore()
</script>
<template><div v-if="!connectivity.online" class="offline-pill">● Offline</div></template>
